export default "__VITE_ASSET__DXah3tBm__"